import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "../../utils/Api";
import Timeformat from "../../utils/Timeformat";
import TableContainer from "../../utils/TableContainer";
import DesignPreviewContainer from "../../utils/DesignPreviewContainer";
import StaticFunctions from "../../utils/StaticFunctions";

const moment = require("moment");

class DesignTable extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        data: PropTypes.array.isRequired,
        onClick: PropTypes.func.isRequired,
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.state = {};

        this.translate = this.props.baseData.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormats = this.props.baseData.languages.getFormatByLanguage(this.userLanguage);

    }

    getTableColumns() {

        return [
            {
                key: 'img',
                nameKey: 'design',
            },
            {
                key:  'designId',
                nameKey: 'designId',
                sortType: 'string',
            },
            {
                key: 'designName',
                nameKey: 'designName',
                sortType: 'string',
            },
            /*{
                key: 'passes',
                nameKey: 'passes',
                classes: 'text-right',
                sortType: 'int',
            },
            {
                key: 'threadbreaks',
                nameKey: 'threadbreaks',
                classes: 'text-right',
                sortType: 'int',
            },
            {
                key: 'minimumPassingTime',
                nameKey: 'minimumPassingTime',
                classes: 'text-right',
                sortType: 'string',
            },
            {
                key: 'averagePassingTime',
                nameKey: 'averagePassingTime',
                classes: 'text-right',
                sortType: 'string',
            },*/
            /*{
                key: 'averageSpeedPerMin',
                nameKey: 'averageSpeedPerMin',
                classes: 'text-right',
                sortType: 'string',
            },*/
            {
                key: 'designStitches',
                nameKey: 'designStitches',
                classes: 'text-right',
                sortType: 'int',
            },
            {
                key: 'dateInserted',
                nameKey: 'dateInserted',
                classes: 'text-right',
                sortType: 'datetime',
            },
        ];

    }

    getTableRows() {

        const timezone = this.props.baseData.companies.currentCompany.timezone;
        const data = this.props.data;
        const rows = [];

        for (let i = 0; i < data.length; i++) {
            const rowTemp = data[i];
            const dateInserted = (rowTemp.date_inserted) ? Timeformat.fromUnix(rowTemp.date_inserted).getFormatedDate(this.timeFormats.datetime, timezone) : '-';

            rows.push({
                id: rowTemp.id,
                img: <DesignPreviewContainer baseData={this.props.baseData} designId={rowTemp.id} designStitches={rowTemp.stitches}/>,
                designId: rowTemp.id,
                designName: rowTemp.name,
                /*passes: (rowTemp.passes) ? rowTemp.passes : 0,
                threadbreaks: rowTemp.threadbreaks,
                minimumPassingTime: (rowTemp.min) ? moment.utc(parseInt(rowTemp.min)).format(this.timeFormats.fullTime) : '-',
                averagePassingTime: (rowTemp.avg) ? moment.utc(parseInt(rowTemp.avg)).format(this.timeFormats.fullTime) : '-',
                averageSpeedPerMin: rowTemp.avgspeed,*/
				designStitches: (rowTemp.stitches) ? StaticFunctions.formatedNumber(rowTemp.stitches) : 0,
                dateInserted: dateInserted,
            });
        }

        return rows;

    }

    render() {

        if (this.props.data.length === 0) return this.translate('noDesignFound');

        const tableColumns = this.getTableColumns();
        const tableRows = this.getTableRows();
        const dataCount = (this.props.designCounter) ? this.props.designCounter : (this.props.data) ? this.props.data.length : 0;
        const countText = (dataCount > 1) ? this.translate('designs') : this.translate('design');

        return (
            <div>
                <div>
                    <p>{StaticFunctions.formatedNumber(dataCount)} {countText} {this.translate('found')}.</p>
                </div>

                <TableContainer
                    name={'design-table'}
                    baseData={this.props.baseData}
                    columns={tableColumns}
                    rows={tableRows}
                    fillGaps="-"
                    onClick={this.props.onClick}
                />
            </div>
        );

    }

}

export default DesignTable;
